/**
 * toolbox-task.component.ts
 * Copyright (c) 2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component } from "@angular/core";

import { AggregationService } from "./aggregation.service";
import { ToolboxActivity } from "./toolbox-activity";
import { ModalService } from "app/common/modal.service";
import { OperatorNode } from "./filter-node";
import { Operators } from "./operators";

export class ToolboxTaskComponent
{
  public task : ToolboxActivity;

  public simpleFilter : boolean = false;

  constructor (
    public service : AggregationService,
    public modals : ModalService
  ) { /* DI (from children) */ }

  /**
   * Ask the agent to start execution of the task.
   */
  public run () : void
  {
    this.service.run(this.task);
  }

  /**
   * Ask the agent to either pause or resume execution.
   */
  public pause (halt : boolean = true) : void
  {
    if (halt)
    {
      this.service.pause(this.task);
    }
    else
    {
      this.service.resume(this.task);
    }
  }

  /**
   * Ask the agent to cancel execution.
   */
  public cancel () : void
  {
    this.service.cancel(this.task);
  }

  /**
   * Explicitly request a progress update on an aggregation task, outside of
   * the regularly-issued updates.
   */
  public getProgress () : void
  {
    this.service.requestProgress(this.task);
  }

  /**
   * Remove the task from the display and release the associated server agent.
   */
  public release () : void
  {
    this.service.release(this.task);
  }

  /**
   * Replace any current filter with the default filter (which provides a
   * bare-bones expression structure to build from).
   */
  public resetFilter (simple : boolean = false) : void
  {
    this.simpleFilter = simple;
    this.task.initDefaultFilter({type : (simple ? "simple" : "advanced")});
  }

  /**
   * Remove the filter entirely and treat the aggregator query as unfiltered.
   */
  public removeFilter () : void
  {
    this.task.clearFilter();
  }

  /**
   * Open a modal to replace the local client-only label for this task.
   */
  public renameTask () : false
  {
    this.modals.stringPrompt({
      title: "Rename analysis task",
      body: `Provide a new name for the task "${this.task.title}":`,
      placeholder: "Analysis Task"
    }).subscribe((name : string) => {
      this.task.title = name;
    });
    return false;
  }

  /**
   * Attempt to save the task's configuration as a template for future
   * execution.
   */
  public saveSchema () : void
  {
    this.modals.stringPrompt({
      title: "Template Name",
      body: "Enter the name you wish to save the template under:",
      placeholder: "Untitled template"
    }).flatMap(
      (name : string) => this.service.saveSchema(this.task, name)
    ).subscribe(() => alert("Save successful"));
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/toolbox-task.component.ts